export default "__VITE_ASSET__2HCw9Jm1__"